export class OrderPaymentError extends Error {
    constructor() {
        super('PAYMENT_ERROR');
    }
}
